import './old/lib/jquery.autoKana.js';

export default () => {
  $(function () {
    $.fn.autoKana('.js-customer-name', '.js-kana-name', {
      katakana: true  //true：カタカナ、false：ひらがな（デフォルト）
    });
    $.fn.autoKana('.js-company-name', '.js-company-kana-name', {
      katakana: true  //true：カタカナ、false：ひらがな（デフォルト）
    });
  });
};
